import { TRANSLATIONS } from "@/i18n";
import { REVERSE_INTENSITIES } from "@/constants/diplomate";

const COLOR_BY_INTENSITY = {
  franc: "#FFDAC1",
  suffit: "#FFB6A0",
  nuclear: "#F28E7C",
};

const LEVEL_LABEL = {
  franc: "I",
  suffit: "II",
  nuclear: "III",
};

/**
 * ReverseIntensityChips — REVERSE only. 3 levels: Franc / Suffit / Nuclear.
 * « Nuclear » = label uniquement — le prompt côté serveur applique des garde-fous
 * (pas de menace, pas de discrimination, pas d'accusation d'infraction).
 */
export const ReverseIntensityChips = ({ lang, value, onChange }) => {
  const t = TRANSLATIONS[lang];
  return (
    <div className="mb-8 sm:mb-10" data-testid="reverse-intensity-chips">
      <div className="flex items-center gap-3 mb-3">
        <span className="dossier-tag font-bold">{t.reverseIntensityLabel}</span>
        <span className="flex-1 h-px bg-black/15" />
      </div>
      <div className="flex flex-wrap gap-2.5 sm:gap-3">
        {REVERSE_INTENSITIES.map((intensity) => {
          const active = value === intensity;
          return (
            <button
              key={intensity}
              data-testid={`reverse-intensity-${intensity}`}
              onClick={() => onChange(intensity)}
              aria-pressed={active}
              className={`inline-flex items-center gap-2 border-2 border-black px-3 sm:px-4 py-2 font-bold text-sm transition-all ${
                active
                  ? "nb-shadow -translate-x-0.5 -translate-y-0.5"
                  : "bg-white nb-shadow-sm hover:-translate-y-0.5 hover:-translate-x-0.5 hover:nb-shadow"
              }`}
              style={active ? { background: COLOR_BY_INTENSITY[intensity] } : undefined}
            >
              <span className="font-mono text-[10px] tracking-widest text-[#4A4A4A]">
                {LEVEL_LABEL[intensity]}
              </span>
              <span>{t.reverseIntensities[intensity]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
